import React from 'react';
import PageLayout from '../components/PageLayout';
import PageHero from '../components/PageHero';

export default function AboutMe() {
  return (
    <PageLayout>
      <PageHero
        eyebrow="About us"
        title="About Us"
        subtitle="Our number one priority is to help you grow your business online."
        className="pb-8 md:pb-10"
        maxWidth="max-w-4xl"
      />

      <section className="px-4 md:px-8 pb-20">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm p-8 md:p-12 rounded-2xl shadow-xl border border-white/20">
            <div className="space-y-6">
              <p
                className="text-base md:text-lg leading-relaxed"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  color: '#292929',
                }}
              >
                We've helped many businesses grow their online presence, and our expertise lies in listening to your needs and building the perfect system tailored just for you. We hold your hand every step of the way, guiding you to grow your online presence and achieve real results.
              </p>

              <p
                className="text-base md:text-lg leading-relaxed"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  color: '#292929',
                }}
              >
                We want you to make more money, get more business, and generate more leads. The world is online now, and your success depends on having a strong digital presence that works for you 24/7.
              </p>

              <p
                className="text-base md:text-lg leading-relaxed"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  color: '#292929',
                }}
              >
                Our approach is simple: we listen, we understand, and we build. We don't just create websites, we create systems that generate leads, convert visitors into clients, and help your business thrive in the digital world. Every business we work with becomes a success story, and we're here to make sure yours is next.
              </p>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
